<section class="menu-access-detail">
    <div class="menu-access-detail-header">
        <div>
            <p class="menu-access-detail-eyebrow">Role Access</p>
            <h2>Sub Menu Role Access</h2>
        </div>
    </div>

    <ag-grid-angular
        class="ag-theme-ulaap menu-access-detail-grid"
        (gridReady)="onGridReady($event)"
        [defaultColDef]="defaultColDef"
        [columnDefs]="subMenuColumnDefs"
        [rowData]="sub_menu_items"
        [masterDetail]="true"
        [detailCellRenderer]="detailCellRenderer"
        [detailRowHeight]="360"
        [rowHeight]="42"
        [headerHeight]="44">
    </ag-grid-angular>
</section>
